export var FlowDecorationColor;
(function (FlowDecorationColor) {
    FlowDecorationColor["Yellow"] = "Yellow";
    FlowDecorationColor["Purple"] = "Purple";
    FlowDecorationColor["Green"] = "Green";
    FlowDecorationColor["Blue"] = "Blue";
    FlowDecorationColor["Pink"] = "Pink";
    FlowDecorationColor["Orange"] = "Orange";
})(FlowDecorationColor || (FlowDecorationColor = {}));
//# sourceMappingURL=constants.js.map